import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GunubirlikTurlar from "../pages/gunubirlik/page";
import KonaklamaliTurlar from "../pages/konaklamali/page";
import UlasimliTatil from "../pages/ulasimli/page";
import YurtdisiTurlar from "../pages/yurtdisi/page";
import Sepet from "../pages/sepet/page";
import TurDetay from "../pages/tur-detay/page";
import AraPage from "../pages/ara/page";
import HakkimizdaPage from "../pages/hakkimizda/page";
import SSSSayfasi from "../pages/sss/page";
import GizlilikPolitikasiPage from "../pages/gizlilik/page";
import KullanimKosullariPage from "../pages/kullanim-kosullari/page";
import AdminPanel from "../pages/admin/page";
import GirisPage from "../pages/giris/page";
import RezervastonPage from "../pages/rezervasyon/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/ara", element: <AraPage /> },
  { path: "/gunubirlik-turlar", element: <GunubirlikTurlar /> },
  { path: "/konaklamali-turlar", element: <KonaklamaliTurlar /> },
  { path: "/ulasimli-tatil", element: <UlasimliTatil /> },
  { path: "/yurtdisi-turlar", element: <YurtdisiTurlar /> },
  { path: "/sepet", element: <Sepet /> },
  { path: "/rezervasyon", element: <RezervastonPage /> },
  { path: "/tur/:id", element: <TurDetay /> },
  { path: "/hakkimizda", element: <HakkimizdaPage /> },
  { path: "/sikca-sorulan-sorular", element: <SSSSayfasi /> },
  { path: "/gizlilik-politikasi", element: <GizlilikPolitikasiPage /> },
  { path: "/kullanim-kosullari", element: <KullanimKosullariPage /> },
  { path: "/giris", element: <GirisPage /> },
  { path: "/admin", element: <AdminPanel /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
